import { render, staticRenderFns } from "./deleteProductLabel.vue?vue&type=template&id=09f189a4"
import script from "./deleteProductLabel.vue?vue&type=script&lang=js"
export * from "./deleteProductLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports